import React, { useState } from "react";
import { Helmet } from "react-helmet";
import "./ContactUs.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Prepare WhatsApp message
    const whatsappMessage = `New Contact Form Submission from wahegurucabs.com website:%0A%0A
Name: ${formData.name}%0A
Email: ${formData.email}%0A
Phone: ${formData.phone}%0A
Message: ${formData.message}`;

    // Open WhatsApp with the pre-filled message
    window.open(`https://wa.me/+919765007100?text=${whatsappMessage}`, '_blank');

    // Reset form and show success message
    setIsSubmitting(false);
    setSubmitSuccess(true);
    setFormData({
      name: "",
      email: "",
      phone: "",
      message: "",
    });

    // Reset success message after 3 seconds
    setTimeout(() => setSubmitSuccess(false), 3000);
  };

  return (
    <div className="contact-page">
      <Helmet>
        <title>
          Contact Waheguru Cabs - Taxi Service in Chhatrapati Sambhajinagar
          (Aurangabad)
        </title>
        <meta
          name="description"
          content="Get in touch with Waheguru Cabs for taxi bookings, inquiries and support in Chhatrapati Sambhajinagar (Aurangabad). Contact us via phone, email or visit our office in Osmanpura."
        />
        <meta
          name="keywords"
          content="contact Waheguru Cabs, Aurangabad taxi service, Chhatrapati Sambhajinagar cab booking, taxi support, cab service contact, Waheguru Cabs phone number"
        />
        <meta
          property="og:title"
          content="Contact Waheguru Cabs - Taxi Service in Aurangabad"
        />
        <meta
          property="og:description"
          content="Reach out to Waheguru Cabs for bookings and inquiries in Chhatrapati Sambhajinagar"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.wahegurucabs.com/contact"
        />
      </Helmet>
      <div className="contact-header">
        <h1 className="contact-title">Contact Us</h1>
        <p className="contact-subtitle">
          Get in touch with our team for any inquiries or support
        </p>
        <div className="header-animation"></div>
      </div>

      <div className="contact-container">
        <div className="contact-info">
          <div className="info-card">
            <div className="info-icon">
              <svg viewBox="0 0 24 24">
                <path d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z" />
              </svg>
            </div>
            <h3>Our Location</h3>
            <p>Shop No.4, Nyati Complex, Besides, Bikaner Sweets, Osmanpura,</p>
            <p>Chh. Sambhajinagar (MH) - 431005</p>
          </div>

          <div className="info-card">
            <div className="info-icon">
              <svg viewBox="0 0 24 24">
                <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" />
              </svg>
            </div>
            <h3>Phone Number</h3>
            <p>+91 9764482121</p>
          </div>

          <div className="info-card">
            <div className="info-icon">
              <svg viewBox="0 0 24 24">
                <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
              </svg>
            </div>
            <h3>Email Address</h3>
            <p>booking@wahegurucabs.com</p>
            <p>support@wahegurucabs.com</p>
          </div>
        </div>

        <div className="contact-form-container">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group floating">
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <label htmlFor="name">Your Name</label>
              <div className="underline"></div>
            </div>

            <div className="form-group floating">
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <label htmlFor="email">Email Address</label>
              <div className="underline"></div>
            </div>

            <div className="form-group floating">
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
              <label htmlFor="phone">Phone Number</label>
              <div className="underline"></div>
            </div>

            <div className="form-group floating">
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              />
              <label htmlFor="message">Your Message</label>
              <div className="underline"></div>
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span className="spinner"></span>
              ) : (
                "Send Message"
              )}
            </button>

            {submitSuccess && (
              <div className="success-message">
                <svg viewBox="0 0 24 24">
                  <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                </svg>
                <span>Message sent successfully!</span>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;